import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { OpenType } from "../interface";
import { compareClientVersion, escapeUrl, getUAClientVersion, isInPrivate } from "../utils";
import ua from '@tencent/docs-user-agent';
import { isNeedScenarioRedirectLink } from "../index";
import ctrlKey from "./ctrl-key-manager";

var isWdocsWebView = function isWdocsWebView() {
  return compareClientVersion(getUAClientVersion('wdocs'), '1.0.0') >= 0;
}; // 私有化微盘和文档公用域名，因此微盘文件的url地址需要加上路径进行区分
// 私有化文档升级后微盘文件域名兼容处理/cgi-bin/disk/s


var isPrivateRE = function isPrivateRE(url) {
  return [/^http(s):\/\/drive\.weixin\.qq\.com\/s\?/i, /^http(s):\/\/drive\.weixin\.qq\.com\/cgi-bin\/disk\/s\?/i].some(function (e) {
    return e.test(url);
  });
};

var isWedriveLink = function isWedriveLink(url) {
  return isInPrivate() ? isPrivateRE(url) : /^http(s):\/\/drive\.weixin\.qq\.com\//i.test(url);
};
/** 是否为B端的品类链接 */


var isEntLink = function isEntLink(url) {
  return [// 融合文档品类
  /^http(s):\/\/doc\.weixin\.qq\.com\/doc/i, /^http(s):\/\/doc\.weixin\.qq\.com\/sheet/i, /^http(s):\/\/doc\.weixin\.qq\.com\/forms/i, /^http(s):\/\/doc\.weixin\.qq\.com\/mind/i, /^http(s):\/\/doc\.weixin\.qq\.com\/flowchart/i, /^http(s):\/\/doc\.weixin\.qq\.com\/slide/i, /^http(s):\/\/doc\.weixin\.qq\.com\/home/i, // 融合文档首页
  /^http(s):\/\/doc\.weixin\.qq\.com\/mall\/m\/profile\/craft/i, // 融合文档模板页
  /^http(s):\/\/doc\.weixin\.qq\.com\/scenario\/login/i, // 融合文档登录页
  /^http(s):\/\/doc\.weixin\.qq\.com\/txdoc/i, // 微文档品类
  /^http(s):\/\/doc\.weixin\.qq\.com\/formcol/i // 旧收集表
  ].some(function (e) {
    return e.test(url);
  });
};

var OpenTarget;
/**
 * 企业微信或微盘中的打开文件处理
 */

(function (OpenTarget) {
  OpenTarget[OpenTarget["REPLACE"] = 0] = "REPLACE";
  OpenTarget[OpenTarget["FORK_WEBVIEW"] = 1] = "FORK_WEBVIEW";
  OpenTarget[OpenTarget["BROWSER"] = 2] = "BROWSER";
  OpenTarget[OpenTarget["NEW_WEBVIEW"] = 3] = "NEW_WEBVIEW";
})(OpenTarget || (OpenTarget = {}));

export function doOpenUrlForWxworkOrWedrive(url, options) {
  /**
   * 这里在企微上有一部分特殊逻辑.
   * 企微里面老版本上不支持replace的参数,直接location.href就完事了..
   * 企微的tdocs.openurl/openinTab接口对入口链接有做白名单.
   * 但是scenario路径不在白名单中
   *  1. b/c跳转的链接:
   *    1.1 在新版本中,直接打开客户端会给打开的链接带上url参数
   *    1.2 老版本中,直接用location来处理.
   *  2. 外部链接
   *    需要调用openInBrowser 接口在外部浏览器中
   *  3. 微盘文件的特殊处理
   */
  try {
    if (ua.isMobile) {
      if (isWdocsWebView()) {
        return openInWedocsWebView(url, options);
      }

      return openInMobileBrowser(url, options);
    }

    if (ua.isWxDrive) {
      return openInWedriveWebView(url, options);
    } // 3.1.18桌面客户端保证了非灰度企业是外部浏览器打开的，所以不用兼容普通的内置webview
    // 另外需要兼容私有化企微的版本号 2.7.2000


    if (ua.isWxWorkVersionAboveOrEqual('3.1.18') || ua.isWxWorkPrivateVersionAboveOrEqual('2.7.2000')) {
      // 判断一下option
      if (options.openType === OpenType.WxworkBrowser) {
        if (ua.isWxWorkVersionAboveOrEqual('4.0.0')) {
          console.log('trigger openInWxworkBrowser');
          return openInWxworkBrowser(url);
        }
      }

      return openInMultiTabWebView(url, options);
    }

    return openInBrowser(url, options);
  } catch (error) {
    console.error('doOpenUrlForWxworkOrWedrive error', error);
    return openInBrowser(url, options);
  }
}
/** 在企业微信的3.1.18的新容器中打开 */

var openInWedocsWebView = function openInWedocsWebView(url, options) {
  var _window, _window$tdocs;

  if ((_window = window) !== null && _window !== void 0 && (_window$tdocs = _window.tdocs) !== null && _window$tdocs !== void 0 && _window$tdocs.openUrl) {
    var target = options.replace ? OpenTarget.REPLACE : isEntLink(url) ? OpenTarget.FORK_WEBVIEW : OpenTarget.NEW_WEBVIEW;
    console.log('doOpenUrlForWxworkOrWedrive use window.tdocs.openUrl', url, _objectSpread(_objectSpread({}, options), {}, {
      target: target
    }));
    return window.tdocs.openUrl({
      url: url,
      target: target,
      style: 3
    });
  }

  return openInMobileBrowser(url, options);
};
/** 在移动端浏览器或其它容器中打开 */


var openInMobileBrowser = function openInMobileBrowser(url, options) {
  var _window2, _window2$mqq, _window2$mqq$ui, _window3, _window3$qmailBridge;

  // 有mqq的话优先使用mqq
  if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$mqq = _window2.mqq) !== null && _window2$mqq !== void 0 && (_window2$mqq$ui = _window2$mqq.ui) !== null && _window2$mqq$ui !== void 0 && _window2$mqq$ui.openUrl) {
    console.log('doOpenUrlForWxworkOrWedrive use window.mqq.ui.openUrl', url, options);
    return window.mqq.ui.openUrl({
      url: url,
      target: options.replace ? 0 : 1,
      style: 3,
      useQQBrowser: true
    });
  } // 有qmailBridge的话优先使用qmailBridge


  if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$qmailBridge = _window3.qmailBridge) !== null && _window3$qmailBridge !== void 0 && _window3$qmailBridge.openDocLink) {
    console.log('doOpenUrlForWxworkOrWedrive use window.qmailBridge.openDocLink', url, options);
    return window.qmailBridge.openDocLink({
      url: url
    });
  }

  return openInBrowser(url, options);
};
/** 在微盘中打开 */


var openInWedriveWebView = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, options) {
    var _window4, _window4$qmailBridge, _window5, _window5$tdocs;

    var fileId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!((_window4 = window) !== null && _window4 !== void 0 && (_window4$qmailBridge = _window4.qmailBridge) !== null && _window4$qmailBridge !== void 0 && _window4$qmailBridge.openFileInWedrive && isWedriveLink(url))) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return fetchFileIdFromSvr(url);

          case 3:
            fileId = _context.sent;
            // if (fileId) {
            // 分享空间有可能fileId是空的，这里不限制。
            console.log('doOpenUrlForWxworkOrWedrive use window.qmailBridge.openFileInWedrive', url, options);
            return _context.abrupt("return", window.qmailBridge.openFileInWedrive(fileId, url));

          case 6:
            if (!((_window5 = window) !== null && _window5 !== void 0 && (_window5$tdocs = _window5.tdocs) !== null && _window5$tdocs !== void 0 && _window5$tdocs.openInTab && isEntLink(url))) {
              _context.next = 9;
              break;
            }

            console.log('doOpenUrlForWxworkOrWedrive use window.tdocs.openInTab', url, options);
            return _context.abrupt("return", window.tdocs.openInTab({
              url: url
            }));

          case 9:
            return _context.abrupt("return", openInBrowser(url, options));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function openInWedriveWebView(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/** 在3.1.18桌面企业微信客户端的多Tab浏览器中打开 */


var openInMultiTabWebView = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
    var _window6, _window6$tdocs, _window7, _window7$tdocs, _window8, _window8$tdocs;

    var fileId;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!options.replace) {
              _context2.next = 4;
              break;
            }

            console.log('doOpenUrlForWxworkOrWedrive use window.location.href', url, options);
            window.location.href = url;
            return _context2.abrupt("return");

          case 4:
            if (!((_window6 = window) !== null && _window6 !== void 0 && (_window6$tdocs = _window6.tdocs) !== null && _window6$tdocs !== void 0 && _window6$tdocs.openFileInWedrive && isWedriveLink(url))) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return fetchFileIdFromSvr(url);

          case 7:
            fileId = _context2.sent;
            // if (fileId) {
            console.log('doOpenUrlForWxworkOrWedrive use window.tdocs.openFileInWedrive', url, options);
            return _context2.abrupt("return", window.tdocs.openFileInWedrive({
              fileId: fileId,
              url: url
            }));

          case 10:
            if (!((_window7 = window) !== null && _window7 !== void 0 && (_window7$tdocs = _window7.tdocs) !== null && _window7$tdocs !== void 0 && _window7$tdocs.openInBrowser && isNeedScenarioRedirectLink(url))) {
              _context2.next = 13;
              break;
            }

            console.log('doOpenUrlForWxworkOrWedrive use window.tdocs.openInBrowser', url, options);
            return _context2.abrupt("return", window.tdocs.openInBrowser({
              url: escapeUrl(url)
            }));

          case 13:
            if (!((_window8 = window) !== null && _window8 !== void 0 && (_window8$tdocs = _window8.tdocs) !== null && _window8$tdocs !== void 0 && _window8$tdocs.openInTab)) {
              _context2.next = 16;
              break;
            }

            console.log('doOpenUrlForWxworkOrWedrive use window.tdocs.openInTab', url, options);
            return _context2.abrupt("return", window.tdocs.openInTab({
              // 如果用户按住 Ctrl 键，静默在后台打开浏览器，不将多 tab 浏览器窗口拉到最前，不 focus 到新打开的 tab
              // 和浏览器行为对齐
              is_silent: ctrlKey.isPressed,
              url: url
            }));

          case 16:
            return _context2.abrupt("return", openInBrowser(url, options));

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function openInMultiTabWebView(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/** 普通浏览器中的打开 */


var openInBrowser = function openInBrowser(url, options) {
  if (options.replace) {
    console.log('doOpenUrlForWxworkOrWedrive use window.location.href', url, options);
    window.location.href = url;
  } else {
    console.log('doOpenUrlForWxworkOrWedrive use window.open', url, options);
    window.open(url);
  }
};
/** 企业微信PC端的内置浏览器打开 */


var openInWxworkBrowser = function openInWxworkBrowser(url) {
  var _window$tdocs2;

  (_window$tdocs2 = window.tdocs) === null || _window$tdocs2 === void 0 ? void 0 : _window$tdocs2.openInWxworkBrowser({
    url: url
  });
};

var fetchFileIdFromSvr = function fetchFileIdFromSvr(url) {
  return new Promise(function (resolve) {
    var cgiUrl = "https://doc.weixin.qq.com/wedoc/getfileinfobyurl?url=".concat(url);
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var data = xhr.responseText;

          try {
            var _res$body;

            var res = JSON.parse(data);
            var fileId = res === null || res === void 0 ? void 0 : (_res$body = res.body) === null || _res$body === void 0 ? void 0 : _res$body.fileid;
            fileId ? resolve(fileId) : resolve(null);
          } catch (e) {
            console.error('fetchFileIdFromSvr error', e);
            resolve(null);
          }
        }
      }
    };

    xhr.onerror = function (e) {
      console.error('fetchFileIdFromSvr error', e);
      resolve(null);
    };

    xhr.ontimeout = function (e) {
      console.error('fetchFileIdFromSvr timeout', e);
      resolve(null);
    };

    xhr.open('GET', cgiUrl, true);
    xhr.setRequestHeader('Content-type', 'text/plain');
    xhr.send();
  });
};